<template>
  <div class="field">
    <div class="field__title h3">
      <p>{{ fieldData.footballFieldName }}</p>
      <p v-if="isManagerRole">
        Статус: <span :style="getColor">{{ fieldData?.fieldStatus?.label }}</span>
      </p>
    </div>

    <div class="field-panel">
      <div>
        <AppMenu
          v-model="activeMenuItem"
          :items="menuItems"
        />
      </div>

      <a
        v-if="isShowDeleted"
        :href="`/update-field/${$route.params.id}`"
        class="field-panel__edit"
      >
        <BaseIcon
          icon="pencil"
          class="field-panel__icon"
        />
      </a>
    </div>

    <KeepAlive>
      <component
        :is="componentName"
      />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppInformation from './components/AppInformation'
import AppEvents from './components/AppEvents'
import AppReviews from './components/AppReviews'
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'FieldPage',
  components: {
    BaseIcon,
    AppMenu,
    AppInformation,
    AppEvents,
    AppReviews
  },
  data () {
    return {
      pageId: this.$route.params.id,
      activeMenuItem: this.$route.query.tab ?? 'information',
      menuItems: [
        { value: 'information', label: 'Информация', component: 'AppInformation' },
        { value: 'events', label: 'События', component: 'AppEvents' },
        { value: 'reviews', label: 'Отзывы', component: 'AppReviews' }
      ],
      fieldData: {
        footballFieldName: '',
        fieldStatus: {}
      }
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    },
    isManagerRole () {
      const roles = this.$store.getters?.['auth/loggedInUser']?.role ?? []
      return roles.includes('ROLE_MANAGER')
    },
    isShowDeleted () {
      const isDeleted = this.fieldData?.fieldStatus.value === 'deleted'
      return !(isDeleted && this.isManagerRole)
    },
    getColor () {
      const val = this.fieldData?.fieldStatus.value
      if (val === 'ready') {
        return { color: '#72FE88' }
      } else if (val === 'deleted') {
        return { color: '#FF3939' }
      }

      return null
    }
  },
  watch: {
    activeMenuItem (newValue) {
      this.$router.push({
        path: this.$route.fullPath,
        query: { tab: newValue }
      })
    }
  },
  async created () {
    await this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        const { data } = await this.$api.field.field(this.$route.params.id)
        this.fieldData.footballFieldName = data?.title
        this.fieldData.fieldStatus = data?.fieldStatus ?? {}
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.field {
  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-panel {
    padding-bottom: 36px;
    margin-top: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__edit {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: inherit;
    }

    &__icon {
      width: 20px;
    }
  }
}
</style>
